import PropTypes from 'prop-types';
import {renderMarkdown} from 'helpers/text-helper';
import {getText} from 'helpers/language-helper';
import {getPlayerModuleSessionData} from 'helpers/module-helper';
import {getModuleMaxPoints, getNumberOfFilledStars} from 'helpers/points-helper';
import Character from 'components/ui/character/character';
import Audio from 'components/ui/audio/audio';
import SpeechBubble from 'components/ui/speech-bubble/speech-bubble';
import './instructions.scss';

const Instructions = ({languageId, playerData, moduleData, taskData, deviceInfo, shouldFadeSpeech = false}) => {

	let text = (taskData.text ? getText(taskData.text, languageId) : null);

	if (taskData.textPassed) {
		const playerModuleSession = getPlayerModuleSessionData(playerData, moduleData.id);
		const points = (playerModuleSession ? playerModuleSession.points : 0);
		const maxPoints = getModuleMaxPoints(moduleData.id);
		const filledStars = getNumberOfFilledStars(points, maxPoints);
		if (filledStars >= 3) {
			text = getText(taskData.textPassed, languageId);
		}
	}

	return (
		<div className={'Instructions ' + 
			(taskData.background ? taskData.background : moduleData.background) +
			' ' + deviceInfo.orientation
		}>
			<div className="Instructions-content">
				{/* Speech & audio */}
				{(taskData.title || taskData.text) && 
					<SpeechBubble 
						type="instructions" 
						taskId={taskData.id} 
						deviceInfo={deviceInfo} 
						shouldFadeSpeech={shouldFadeSpeech}
					>
						{taskData.title && <div className="Instructions-title">
							{getText(taskData.title, languageId)}
						</div>}
						{text && <div className="Instructions-text">
							{renderMarkdown(text)}
						</div>}
						<div className="Instructions-audio">
							<Audio 
								type='task-intro'
								color='blue'
								fileName={languageId + '-' + taskData.taskId}
							/>
						</div>
					</SpeechBubble>
				}

				{/* Characters */}
				{taskData.characters.map((characterId) => {
					return (<div key={characterId} className={'Instructions-character ' + characterId}>
						<Character 
							page="instructions" 
							characterId={characterId}
						/>
					</div>);
				})}
			</div>
		</div>
	);
};

Instructions.propTypes = {
	languageId: PropTypes.string.isRequired,
	playerData: PropTypes.object.isRequired,
	moduleData: PropTypes.object.isRequired,
	taskData: PropTypes.object.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	shouldFadeSpeech: PropTypes.bool,
};

export default Instructions;
